export enum ResetPasswordSource {
    RESET_PASSWORD = 'reset_password',
    JOINT_ACCOUNT_HOLDERS_INVITATION = 'joint_account_holder_invitation',
    PARTNER_MEMBER_INVITATION = 'partner_member_invitation',
    RETURNING_MEMBER = 'returning_member',
}

export interface ForgotPasswordRequest {
    email: string;
    source?:
        | ResetPasswordSource.RESET_PASSWORD
        | ResetPasswordSource.RETURNING_MEMBER;
    /** Round-tripped through the emailed reset link so the returning-member
     * info screen can recover it even on a different device/browser. */
    visitorId?: string;
}

export interface ForgotPasswordResponse {
    /** Only set when the request carried a `source`. `true` = no email
     * was sent; account is already active. */
    isActiveMember?: boolean;
}

export interface ResetPasswordRequest {
    password: string;
    token: string;
}

export interface ResetPasswordResponse {
    user_id?: string;
    user?: {
        emails?: Array<{ email: string }>;
        /** Set by the backend at forgotPassword time — Stytch redirect urls
         * must exactly match a dashboard-registered url, so a per-request
         * visitor id can't ride along as a query param and goes here instead. */
        trusted_metadata?: { visitor_id?: string };
    };
    session_token?: string;
    session_jwt?: string;
}

export interface StytchPasswordFeedback {
    message: string;
    suggestions?: string[];
}

export interface GetDeviceTokenRequest {
    stytchId: string;
    sessionId: string;
    isFirstLogin: boolean;
}

export interface DeviceTokenResponse {
    expires: Date;
    token: string;
    isFirstLogin: boolean;
    stytchId: string;
}

export enum OnboardingPromptRoutes {
    BIOMETRICS = '/onboarding/biometrics',
    NOTIFICATIONS = '/onboarding/notifications',
}

export enum LogoutType {
    LogoutButton = 'LogoutButton',
    Inactivity = 'Inactivity',
    NoAccessScreenButton = 'NoAccessScreenButton',
}

export interface PasswordRequirementsFeedback {
    missingCharacters: number;
    missingComplexity: number;
    breachedPassword: boolean;
}

export interface LudsCheckPasswordResponse {
    valid_password: boolean;
    breached_password: boolean;
    feedback: {
        luds_requirements: {
            missing_complexity: number;
            missing_characters: number;
        };
    };
}

export interface CheckPasswordResponse {
    validPassword: boolean;
    message?: string;
    strengthCheck?: PasswordRequirementsFeedback;
}
